import { Stack, Tooltip } from '@mui/material';
import { useProcessSettings } from '@/shared/context/ProcessSettingsProvider';

export type ProcessStatusBarProps = {
  type: string;
  count: number;
  percentage: number;
};

export function ProcessStatusBar({
  type,
  count,
  percentage,
}: ProcessStatusBarProps) {
  const { getProcessTypeConfig } = useProcessSettings();

  // Handle idle units specially
  const isIdle = type === 'idle';
  const config = isIdle
    ? { displayName: 'Idle', color: '#e5e7eb' } // Light gray color for idle
    : getProcessTypeConfig(type);

  return (
    <Tooltip title={`${count} ${config.displayName} (${percentage.toFixed(0)}%)`}>
      <Stack
        className="h-8 rounded-sm transition-all hover:opacity-80"
        sx={{
          width: `${percentage}%`,
          backgroundColor: config.color,
        }}
      />
    </Tooltip>
  );
}
